import { therapyPlanningAction } from 'src/redux/actions/constant';

const {
  UPDATE_UNCOVERED_DAY_THERAPY_PLANNING_FAILURE,
  UPDATE_UNCOVERED_DAY_THERAPY_PLANNING_LOADING,
  UPDATE_UNCOVERED_DAY_THERAPY_PLANNING_RESET,
  UPDATE_UNCOVERED_DAY_THERAPY_PLANNING_SUCCESS,
} = therapyPlanningAction;

const intitialstate: object = {
  response: null,
  loading: false,
  isDayUpdated: false,
};

export const updateUncoveredDayIn_TP20_reducer = (state = intitialstate, action: any) => {
  switch (action.type) {
    case UPDATE_UNCOVERED_DAY_THERAPY_PLANNING_SUCCESS: {
      return {
        ...state,
        response: action.payload?.response,
        loading: false,
        isDayUpdated: true,
      };
    }

    case UPDATE_UNCOVERED_DAY_THERAPY_PLANNING_FAILURE:
      return {
        ...state,
        response: action.payload,
        loading: false,
        isDayUpdated: false,
      };
    case UPDATE_UNCOVERED_DAY_THERAPY_PLANNING_LOADING:
      return {
        ...state,
        loading: true,
      };

    case UPDATE_UNCOVERED_DAY_THERAPY_PLANNING_RESET:
      return intitialstate;

    default:
      return state;
  }
};
